module.exports = "../dist/frontend/icons/ui/ig.svg?61a60b9d352d45bc5946a135009b8091";